import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{ padding:'2rem' }}>
    <h1 style={{ marginTop:0 }}>404 - Page Not Found</h1>
    <p>The page you requested does not exist.</p>
    <Link to="/">Return to Dashboard</Link>
  </div>
);

export default NotFound;
